import {
  ApiService,
} from '@/internal';

export default class CalendarService extends ApiService {
  index(params = {}) {
    return this.request({
      method: 'get',
      url: 'calendar',
      params,
    });
  }

  schedule(templateId, workoutAt) {
    return this.request({
      method: 'post',
      url: `template/${templateId}/schedule`,
      data: {
        workout_at: workoutAt,
      },
    });
  }
}
